import { BFFAgent } from "BFFAgent"
import { FIELD_TYPES } from "common/hooks/useForm"
import { VALIDATION } from "common/RangeInput"
import { capitalize, sortBy } from "lodash"

export const SALE_TABS = {
  conventional : 0,
  direct: 1,
  used : 2,
}

export const TABLE_SELECTED = {
  brandModels : 0,
  versions: 1,
  stocks: 2,
}

export const MESSAGE_TOOLTIP = {
  bonification : "Este importe se descontará directamente sobre el precio de venta.",
  discount : "Máximo descuento posible de aplicar sobre el precio de venta.",
  increment:"Máximo incremento posible de aplicar sobre el valor de los usados que ingresen como parte de pago.",
  remember :"Este recordatorio solo se visualizará en el módulo de Políticas de precios.",
  titleError :"Para editar este valor primero tenés que actualizar los campos que se marcan en rojo.",
  generalDiscount: "Descuento posible de aplicar sobre el precio de venta de todos los autos de la marca, modelo y versión seleccionada.",
  observation: "Esta observación se visualizará por todos los usuarios, en aquellos módulos donde aparezca el vehículo."
}

export const TITTLE_TOOLTIP = {
  carLotTitle:"Bonificación por concesionario:",
  carLotText:"Importe que se descontará directamente sobre el precio de venta.",
  generalDiscountTitle: "Descuento general:",
  generalDiscountText: "Descuento posible de aplicar sobre el precio de venta de todos los autos seleccionados.",
  specificDiscountTitle:"Descuento específico:",
  specificDiscountText:"Máximo descuento posible a aplicar sobre el precio de venta.",
  incrementTitle:"Incremento en la toma de usados:",
  incrementText:"Máximo incremento posible de aplicar sobre el valor de los usados que ingresen como parte de pago.",
  stockSpecificDiscount : "Descuento adicional posible de aplicar sobre el precio de venta del auto seleccionado.",
  stockSpecificDiscountGrupal : "Descuento adicional posible de aplicar sobre el precio de venta de los autos seleccionados.",
  directSalesRankDiscountsHeader : "Descuento posible de aplicar sobre el precio de venta de los autos seleccionados, según los rangos de cantidad determinados.",
} 

export const MESSAGE_ERROR_TOAST = {
  individualEditionUsed :"No se puede cargar un descuento con un importe mayor al precio de venta del Vehículo",
  individualEdition :"No se puede cargar un descuento con un importe mayor al precio de venta del el VIN seleccionado.",
  groupalEdition:"No se puede cargar un descuento con un importe mayor al precio de venta de alguno de los VIN seleccionados.",
}

export const OPERATOR_TYPE = {
    percentage: 'percentage',
    amount: 'amount'
}

export const BONIFICATION_USED_TYPES = [
  {
    label: 'Bonificación por concesionario',
    value: 'Bonificación por concesionario'
  },
  {
    label: 'Descuento especifico',
    value: 'Descuento especifico'
  },
  {
    label: 'Incremento en la toma de usados',
    value: 'Incremento en la toma de usados'
  }
]

export const BONIFICATION_CONVENTIONAL_TYPES = [
  {
    label: 'Bonificación por concesionario',
    value: 'Bonificación por concesionario'
  },
  {
    label: 'Descuento general',
    value: 'Descuento general'
  },
  {
    label: 'Incremento en la toma de usados',
    value: 'Incremento en la toma de usados'
  }
]

export const maskFuntions = {
  removeMask: value => {
      if (_isEmptyValue(value)) return ''
      return Number(
          String(value)
              .split('.')
              .join('')
      )
  },
  applyMask: value => {
      if (_isEmptyValue(value)) return ''
      const intMask = new Intl.NumberFormat('es-Ar')
      return intMask.format(value)
  }
}

const _isEmptyValue = (value) => !Boolean(value) && value !== 0

export const dependenciesFilter = {
  'brands': ['models', 'versions'],
  'models': ['versions']
}

export const dependeciesFilterStock = {
  'brands': ['models', 'versions'],
  'models': ['versions'],
}

export const ERRORS_CODES = {
  0: 'El valor debe ser mayor al campo Desde'
}
//Esta función completa los criterios con los que se va a filtrar en el modal de filtros de cada tab(convencional, directa, usado)
//Para el modal de filtros de usados se filtra por Sucursal, Año, Km, Antigüedad, Precio, Marca, Modelo y Version
export const usedFilterItemsSchema = [
  {
      key: 'branchOffices',
      name: 'Sucursal',
      type: FIELD_TYPES.CHECKBOXES,
      internalProps: {
          alwaysExpanded: true
      },
      order: 0,
      asyncFuntion: async ({params, currentField}) => {
          let { data } = await BFFAgent.PricePolicy.getBranchOfficeByCarLots(params)
          return sortBy(data, 'name')?.map(({ name }) => ({
              value: name,
              label: name,
              checked: Boolean(currentField.options.filter(({value, checked}) => value.toString() === name.toString() && checked).length)
          }))
      },
  },
  {
      key: 'year',
      name: 'Año',
      type: FIELD_TYPES.RANGE,
      internalProps: {
          errors: Object.values(ERRORS_CODES),
          validationType: VALIDATION.YEAR.field
      },
      order: 1
  },
  {
      key: 'kilometres',
      name: 'Kilómetros',
      type: FIELD_TYPES.RANGE,
      internalProps: {
          errors: Object.values(ERRORS_CODES),
          maskFuntions,
          validationType: VALIDATION.INTEGER.field
      },
      order: 2
  },
  {
      key: 'antiquity',
      name: 'Antigüedad',
      type: FIELD_TYPES.RANGE,
      internalProps: {
          errors: Object.values(ERRORS_CODES),
          maskFuntions,
          validationType: VALIDATION.INTEGER.field
      },
      order: 3
  },
  {
      key: 'price',
      name: 'Precio de venta',
      type: FIELD_TYPES.RANGE,
      internalProps: {
          errors: Object.values(ERRORS_CODES),
          maskFuntions,
          validationType: VALIDATION.INTEGER.field
      },
      order: 4
  },
  {
      key: 'brands',
      name: 'Marca',
      type: FIELD_TYPES.CHECKBOXES,
      dependencies: [],
      asyncFuntion: async ({params, currentField}) => {
        const { data } = await BFFAgent.PricePolicy.getBrandsByCarLots(params)
        let res = sortBy(data, 'name')?.map(({ name }) => ({
            value: name,
            label: name,
            checked: Boolean(currentField.options.filter(({value, checked}) => value.toString() === name.toString() && checked).length)
        }))
        if (res.length === 1) {
          return res.map(opt => ({ ...opt, checked: true, disabled: true }))
        }
        return res;
      },
      order: 5,
      internalProps: {
        showText: 'VER TODAS'
      }
  },
  {
      key: 'models',
      name: 'Modelo',
      type: FIELD_TYPES.CHECKBOXES,
      dependencies: [],
      asyncFuntion: async ({params, field, currentField}) => {
          if(!field) return;
          const brandNames = field.options?.filter(opt => opt.checked).map(optMapped => optMapped.value);
          if(brandNames.length >=2 ) {
            return [{value: 'Todos', label: 'Todos', checked: true, disabled: true }]
          }
          const {data} = await BFFAgent.PricePolicy.getModelsByBrandName({...params, brandNames})
          return sortBy(data, 'name')?.map(({name}) => ({
            value: name,
            label: name,
            checked: Boolean(currentField.options.filter(({value, checked}) => value.toString() === name.toString() && checked).length)
          }));
      },
      loading: false,
      internalProps:{
        textDisabled:'Para visualizar los modelos debes seleccionar al menos una marca.'  
      },
      order: 6
  },
  { 
      key: 'versions',
      name: 'Versión',
      type: FIELD_TYPES.CHECKBOXES,
      dependencies: [],
      asyncFuntion: async ({params, field, currentField}) => {
          if(!field) return;

          const arrayDisabled = [{value: 'Todas', label: 'Todas', checked: true, disabled: true }]
          const modelNames = field.options?.filter(opt => opt.checked).map(optMapped => optMapped.value);

          if((field.key === 'brands' || field.key === 'models') && modelNames.length >=2){
            return arrayDisabled;
          }
        
          const {data} = await BFFAgent.PricePolicy.getVersionByModelName({...params, modelNames})
          return sortBy(data, 'version')?.map(({version}) => ({
            value: version,
            label: version,
            checked: Boolean(currentField.options.filter(({value, checked}) => value.toString() === version.toString() && checked).length)
          }));
      },
      loading: false,
      internalProps:{
          textDisabled:'Para visualizar las versiones debes seleccionar al menos un modelo.',
          showText: 'VER TODAS'
        },
      order: 7
  }
]


//Para el modal de filtros de la tabla version de convencional se filtra por Marca, Modelo y Version
export const conventionalVersionsFilterItemsSchema= [
  {
    key: 'brands',
    name: 'Marca',
    type: FIELD_TYPES.CHECKBOXES,
    dependencies: [],
    asyncFuntion: async ({params, currentField}) => {
      const { data } = await BFFAgent.PricePolicy.getBrandsByCarLots(params)
      let res = sortBy(data, 'name')?.map(({ name }) => ({
          value: name,
          label: name,
          checked: Boolean(currentField.options.filter(({value, checked}) => value.toString() === name.toString() && checked).length)
      }))
      if (res.length === 1) {
        return res.map(opt => ({ ...opt, checked: true, disabled: true }))
      }
      return res;
    },
    order: 0,
    internalProps: {
      alwaysExpanded: true
    }
  },
  {
    key: 'models',
    name: 'Modelo',
    type: FIELD_TYPES.CHECKBOXES,
    dependencies: [],
    asyncFuntion: async ({params, field, currentField}) => {

        if(!field) return;
        const brandNames = field.options?.filter(opt => opt.checked).map(optMapped => optMapped.value);
        if(brandNames.length >=2 ) {
          return [{value: 'Todos', label: 'Todos', checked: true, disabled: true }]
        }
        const {data} = await BFFAgent.PricePolicy.getModelsByBrandName({...params, brandNames})
        return sortBy(data, 'name')?.map(({name}) => ({
          value: name,
          label: name,
          checked: Boolean(currentField.options.filter(({value, checked}) => value.toString() === name.toString() && checked).length)
        }));
    },
    loading: false,
    internalProps:{
      alwaysExpanded:true,
      textDisabled:'Para visualizar los modelos debes seleccionar al menos una marca.'  
    },
    order: 1

  },
  { 
    key: 'versions',
    name: 'Versión',
    type: FIELD_TYPES.CHECKBOXES,
    dependencies: [],
    asyncFuntion: async ({params, field, currentField}) => {
        if(!field) return;
        if(field.key !== 'models') return
        const arrayDisabled = [{value: 'Todas', label: 'Todas', checked: true, disabled: true }]
        const brandsOrModelsNames = field.options?.filter(opt => opt.checked).map(optMapped => optMapped.value);

        if((field.key === 'brands' || field.key === 'models') && brandsOrModelsNames.length >=2){
          return arrayDisabled;
        }
      
        const {data} = await BFFAgent.PricePolicy.getVersionByModelName({...params, modelNames: brandsOrModelsNames})
        return sortBy(data, 'version')?.map(({version}) => ({
          value: version,
          label: version,
          checked: Boolean(currentField.options.filter(({value, checked}) => value.toString() === version.toString() && checked).length)
        }));
    },
    loading: false,
    internalProps:{
        alwaysExpanded: true,
        textDisabled:'Para visualizar las versiones debes seleccionar al menos un modelo.',
      },
    order: 2
  }
]
//Para el modal de filtros de la tabla version de convencional se filtra por Marca, Modelo, Version, Sucursal, Certificado de Pago y Antigüedad
  export const conventionalStocksFilterItemsSchema = [
  {
      key: 'brands',
      name: 'Marca',
      type: FIELD_TYPES.CHECKBOXES,
      dependencies: [],
      internalProps: {
        alwaysExpanded: true,
      },
      asyncFuntion: async ({params, currentField}) => {
        const { data } = await BFFAgent.PricePolicy.getBrandsByCarLots(params)
        let res = sortBy(data, 'name')?.map(({ name }) => ({
            value: name,
            label: name,
            checked: Boolean(currentField.options.filter(({value, checked}) => value.toString() === name.toString() && checked).length)
        }))
        if (res.length === 1) {
          return res.map(opt => ({ ...opt, checked: true, disabled: true }))
        }
        return res;
      },
     order: 0
  },
  {
      key: 'models',
      name: 'Modelo',
      type: FIELD_TYPES.CHECKBOXES,
      dependencies: [],
      asyncFuntion: async ({params, field, currentField}) => {
          if(!field) return;
          const brandNames = field.options?.filter(opt => opt.checked).map(optMapped => optMapped.value);
          if(brandNames.length >=2 ) {
            return [{value: 'Todos', label: 'Todos', checked: true, disabled: true }]
          }
          const newParams = {...params, brandNames}
          const {data} = await BFFAgent.PricePolicy.getModelsByBrandName(newParams)
          return sortBy(data, 'name')?.map(({name}) => ({
            value: name,
            label: name,
            checked:  Boolean(currentField.options.filter(({value, checked}) => value.toString() === name.toString() && checked).length)
          }));
      },
      loading: false,
      internalProps:{
        textDisabled:'Para visualizar los modelos debes seleccionar al menos una marca.'  
      },
      order: 1
  },
  { 
      key: 'versions',
      name: 'Versión',
      type: FIELD_TYPES.CHECKBOXES,
      dependencies: [],
      asyncFuntion: async ({params, field, currentField}) => {
          if(!field) return;
          const arrayDisabled = [{value: 'Todas', label: 'Todas', checked: true, disabled: true }]
          const brandsOrModelsNames = field.options?.filter(opt => opt.checked).map(optMapped => optMapped.value);
          if((field.key === 'brands' || field.key === 'models') && brandsOrModelsNames.length >=2){
            return arrayDisabled;
          }
          if(field.key !== 'models') return
          const newParams = {...params, modelNames: brandsOrModelsNames}
          const {data} = await BFFAgent.PricePolicy.getVersionByModelName(newParams)
          return sortBy(data, 'version')?.map(({version}) => ({
            value: version,
            label: version,
            checked: Boolean(currentField.options.filter(({value, checked}) => value.toString() === version.toString() && checked).length)
          }));
      },
      internalProps:{
          textDisabled:'Para visualizar las versiones debes seleccionar al menos un modelo.'
        },
      order: 2
  },
  {
      key: 'branchOffices',
      name: 'Sucursal',
      type: FIELD_TYPES.CHECKBOXES,
      internalProps: {
          alwaysExpanded: true,
      },
      order: 3,
      asyncFuntion: async ({params, currentState}) => {
          const {brands, models, versions} = currentState
          let modelSelected = []
          let versionSelected = []
          const brandSelected = brands?.options.filter(brand => brand.checked === true)
          if (brandSelected?.length === 1) {
            modelSelected = models?.options.filter(model => model.checked === true)
            if (modelSelected?.length === 1) {
              versionSelected = versions?.options.filter(version => version.checked === true)
            }
          }
          const query = {
            ...params,
            brands: brandSelected || [],
            models: modelSelected || [],
            versions: versionSelected || []
          }
          let { data } = await BFFAgent.PricePolicy.getBranchOfficeByCarLots(query)
          return sortBy(data, 'name')?.map(({ name }) => ({
              value: name,
              label: name,
              checked: Boolean(currentState?.branchOffices?.options?.filter(({value, checked}) => value.toString() === name.toString() && checked).length)
          }))
      },
  },
  {
      key: 'paymentCertificate',
      name: 'Certificado de pago',
      type: FIELD_TYPES.CHECKBOXES,
      internalProps: {
        alwaysExpanded: true
      },
      options: [        
        {
          label: "Con certificado",
          value: "Si",
        },
        {
          label: "Sin certificado",
          value: "No"
        }
      ],
      order: 4
  },
  {
      key: 'antiquity',
      name: 'Antigüedad',
      type: FIELD_TYPES.RANGE,
      internalProps: {
          errors: Object.values(ERRORS_CODES),
          maskFuntions,
          validationType: VALIDATION.INTEGER.field
      },
      order: 5
  }
]

export const formatFilterModalState = ({ modalState, formatBackend= false }) => {
  let filterArray = []
  Object.keys(modalState).forEach(
    (key) => {
      // logic for checkbox
      const currentFilter = modalState[key]
      if (currentFilter.type === FIELD_TYPES.CHECKBOXES) {
        const checkedOptions = currentFilter.options.filter(opt=> opt.checked && !(opt?.disabled || false))
        if(checkedOptions.length) {
          checkedOptions.forEach( (option) => {
            filterArray.push({
              key, 
              value: option.value,
              label: option.label,
              type: currentFilter.type,
              keyBackend: key
            })
          })
        }
      } else if (currentFilter.type === FIELD_TYPES.SELECT) {
        const checkedOptions = currentFilter.options.filter(opt=> !(opt?.disabled || false))
        if(checkedOptions.length) {
          checkedOptions.forEach( (option) => {
            filterArray.push({
              key: currentFilter.key || key, 
              value: option.value,
              label: option.value,
              type: currentFilter.type,
              keyBackend: currentFilter.key || key
            })
          })
        }
      } else if(currentFilter.type === FIELD_TYPES.RANGE) {
        const rangeObj = currentFilter.value;
        if (formatBackend) {
          if(rangeObj.to){
            const toKey = `to${capitalize(currentFilter.key)}`
            filterArray.push({
              key,
              value:rangeObj.to,
              type: currentFilter.type,
              keyBackend: toKey
            })
          }
          if(rangeObj.from) {
            const fromKey = `since${capitalize(currentFilter.key)}`
            filterArray.push({
              key,
              value:rangeObj.from,
              type: currentFilter.type,
              keyBackend: fromKey
            })
          }
        } else {
          filterArray.push({
            key,
            value: getLabelChip(currentFilter),
            label: getLabelChip(currentFilter),
            type: currentFilter.type,
          })
        }
      }
    }
  )
  return filterArray;
}

const getLabelChip = field => {
  const rangeObj = field.value;
  if(rangeObj?.from === rangeObj?.to){
    switch (field.key) {
      case 'year':
        return `Año ${rangeObj?.from}`
      case 'kilometres':
        return `${rangeObj?.from}km`
      case 'antiquity':
        return `${rangeObj?.from} días de antigüedad`
      case 'price':
        return `$${rangeObj?.from}`
      default:
        return `${rangeObj.from}`;
    }
  } else if(rangeObj?.from && rangeObj?.to) {
    switch (field.key) {
      case 'year':
        return `Año ${rangeObj?.from} a ${rangeObj?.to}`
      case 'kilometres':
        return `Desde ${rangeObj?.from}km a ${rangeObj?.to}km`
      case 'antiquity':
        return `Desde ${rangeObj?.from} a ${rangeObj?.to} días de antigüedad`
      case 'price':
        return `Desde $${rangeObj?.from} a $${rangeObj?.to}`
      default:
        return `${rangeObj.from} ${rangeObj.to}`;
    }
  } else {
    switch (field.key) {
      case 'year':
        return `${rangeObj?.from ? 'Desde' : 'Hasta'} año ${rangeObj?.from || rangeObj?.to}`
      case 'kilometres':
        return `${rangeObj?.from ? 'Desde' : 'Hasta'} ${rangeObj?.from || rangeObj?.to}km`
      case 'antiquity':
        return `${rangeObj?.from ? 'Desde' : 'Hasta'} ${rangeObj?.from || rangeObj?.to} días de antigüedad`
      case 'price':
        return `${rangeObj?.from ? 'Desde' : 'Hasta'} $${rangeObj?.from || rangeObj?.to}`
      default:
        return `${rangeObj.from || rangeObj.to}`;
    }
  }
}

export const formatFilterChips = stateFilters => {
  let chipsArray = [];

  if(stateFilters.length){
      const resYear = stateFilters.filter(element => element.key.includes('year'));
      if(resYear.length === 2){
          let label =  `Año ${resYear[0].value.from} a ${resYear[1].value.to}`;
          if(resYear[0].value.from === resYear[0].value.to){
              label = `Año ${resYear[0].value.from}`
          }
          chipsArray.push({
              label,
              key: resYear[0].key
          })
      } else {
          chipsArray.push({
              label:`${resYear[0].value?.from ? 'Desde' : 'Hasta'} año ${resYear[0].value}`,
              key: resYear[0].key
          })
      }

      const resKm = stateFilters.filter(element => element.key.includes('kilometres'));
      if(resKm.length === 2){
          let label =  `Desde ${resKm[0].value.from}km a ${resKm[1].value.to} km`;
          if(resKm[0].value.from === resKm[0].value.to){
              label = `${resKm[0].value.from} km`
          }
          chipsArray.push({
              label,
              key: resKm[0].key
          })
      } else {
          chipsArray.push({
              label:`${resKm[0].value?.from ? 'Desde' : 'Hasta'} ${resKm[0].value} km`
          })
      }

      const resAntq = stateFilters.filter(element => element.key.includes('antiquity'));
      if(resAntq.length === 2){
          let label =  `Desde ${resAntq[0].value.from} a ${resAntq[1].value.to} días de antigüedad`;
          if(resAntq[0].value.from === resAntq[0].value.to){
              label = `${resAntq[0].value.from} días de antigüedad`
          }
          chipsArray.push({
              label,
              key: resAntq[0].key
          })
      } else {
          chipsArray.push({
              label:`${resAntq[0].value?.from ? 'Desde' : 'Hasta'} ${resAntq[0].value} días de antigüedad`
          })
      }
      
      const resPrice = stateFilters.filter(element => element.key.includes('price'));
      if(resPrice.length === 2){
          let label =  `Desde $ ${resPrice[0].value.from} a $ ${resPrice[1].value.to}`;
          if(resPrice[0].value.from === resPrice[0].value.to){
              label = `$ ${resKm[0].value.from}`
          }
          chipsArray.push({
              label,
              key: resPrice[0].key
          })
      } else {
          chipsArray.push({
              label:`${resPrice[0].value?.from ? 'Desde' : 'Hasta'} $ ${resPrice[0].value}`
          })
      }

      stateFilters.forEach(element => {
          let keys = ['branchOffices', 'brands', 'models', 'versions']
          if(keys.includes(element.key)) {
              chipsArray.push({
                  label:`${element.value}`,
                  key: element.key,
                  value: element.value
              })
          }
      });
  }

  return chipsArray;
}

export const getQueryConfig = ({nuevo, venta_convecional, venta_directa, needStock}) => {
  let query = ''
  query = 'nuevo=' + nuevo + '&';
  query += 'venta_convencional=' + venta_convecional + '&';
  query += 'venta_directa=' + venta_directa + '&';
  if(needStock) query += 'needStock=' + needStock + '&';
  query = query.slice(0, -1);
  return query;
}

export const formatInitialFilterChips = (
  initialFilters,
  carlotSelected,
  handleFiltersStock,
) => {
      const keys = Object.keys(initialFilters)
      let filters = {}
      keys.forEach(key => {
          filters[key] = {
              key: key,
              name: initialFilters[key].name,
              type: FIELD_TYPES.CHECKBOXES,
              order: initialFilters[key].order,
              params: {
                  carLots: carlotSelected,
                  reFetch: true
              },
              options: [
                {
                    value: initialFilters[key].value,
                    label: initialFilters[key].value,
                    checked: true
                }
            ]
          }
      })
      handleFiltersStock(filters)
}
